import * as React from "react";
import { Create, SimpleForm } from "react-admin";

import TextInputRA from "../components/TextInputRA";
import HiddenInputRA from "../components/HiddenInputRA";

import LayoutContainer from "../components/LayoutContainer";
/*
{
  "locale": "en-US",
  "type": "Product",
  "name": "Ear Pod",
  "desc": "description",
  "base_price": 1000,
  "retail_price": 10000,
  "currency": "THB",
  "unit": "Piece",
  "hashtags[]": [
    "#iphone"
  ],
    "status": "Active",
  "sub_category_id": "xxxxxx-5902ca0b0257bb14df426921",
  "category_id": "xxxxxx-5902ca0b0257bb14df426921",
  "realm_id": "xxxxxx-5902ca0b0257bb14df426921",
  "branch_id": "xxxxxx-5902ca0b0257bb14df426921",
  "action": "upload_image"
*/

const CategoryCreate = (props) => (
  <LayoutContainer>
    <Create {...props} title="Create Supplier">
      <SimpleForm redirect="list">
        <TextInputRA label="Supplier name" source="name" required />
        <TextInputRA label="Description" source="desc" />
        <TextInputRA label="Business type" source="business_type" required />
        <TextInputRA label="Tax id" source="tax_id" />
        <TextInputRA label="Contact person 1" source="contact1" required />
        <TextInputRA label="Contact person 2" source="contact2" />
        <TextInputRA label="Phone" source="phone" required type="phone" />
        <TextInputRA label="Email" source="email" required />
        <TextInputRA label="Address" source="address" required />
        <HiddenInputRA source="status" initialValue="Active" />
      </SimpleForm>
    </Create>
  </LayoutContainer>
);

export default CategoryCreate;
